import cn from "classnames";
import { AddressField, Checkbox, Field, Flags, Select } from "components/shared/form";
import { formatInitial, serializeReq, validateForm } from "helpers/form";
import React, { Component } from "react";

export default class TemplateTab extends Component {
    initialState = {};

    constructor(props) {
        super(props);
        this.state = {
            data: props.initialState,
            isValid: true,
            shouldUpdate: false,
        };
    }

    componentDidMount() {
        const { data, initialState } = this.props;
        if (data) {
            this.setState({ data: formatInitial(data, initialState) });
        }
    }

    syncDataFromProps = (prevProps) => {
        const { shouldUpdate, data, initialState, updateToggle } = this.props;
        const propsChanged =
            prevProps.shouldUpdate !== shouldUpdate ||
            prevProps.data !== data ||
            prevProps.initialState !== initialState;

        if (propsChanged && shouldUpdate && updateToggle) {
            updateToggle(false);
            this.setState({ data: formatInitial(data, initialState) });
        }
    };

    componentDidUpdate(prevProps) {
        this.syncDataFromProps(prevProps);
    }

    compareStateAndProps = (props, state) => {
        const formattedProps = formatInitial(props, this.props.initialState);
        for (const key in formattedProps) {
            if (formattedProps[key] !== state[key]) {
                return true;
            }
        }
        return false;
    };

    isValidForm = (state) => {
        const { config } = this.props;
        return validateForm(config, serializeReq(state));
    };

    setValue = ({ value, name }) => {
        let data = { ...this.state.data };
        if (name === "address") {
            data.address = value.address;
            data.location = value.location;
            data.city = value.city;
            data.street = value.street;
            data.houseNumber = value.houseNumber;
        } else {
            data = { ...this.state.data, [name]: value };
        }
        const shouldUpdate = this.compareStateAndProps(this.props.data, data);
        const isValid = this.isValidForm(data);
        this.setState({ data, shouldUpdate, ...(isValid ? { isValid: true } : {}) });
    };

    update = () => {
        const { shouldUpdate, data } = this.state;
        if (!this.isValidForm(data)) {
            return this.setState({ isValid: false });
        }
        if (shouldUpdate) {
            return this.props
                .action(data)
                .then((res) => {
                    if (res) {
                        this.props.update();
                    } else {
                        this.setState({ isValid: false });
                    }
                })
                .then(() => this.setState({ shouldUpdate: false }));
        }
    };

    renderAddressField = (props) => (
        <AddressField
            wrapper="panel__row"
            onChange={this.setValue}
            labelWrapper="col-form-label col-form-label-sm col-12 text-muted"
            fieldWrapper="col-12"
            bWrapper="row mb-2"
            {...props}
        />
    );

    renderField = (props) => {
        return (
            <Field
                wrapper="panel__row"
                onChange={this.setValue}
                value={this.state.data[props.inputProps.name]}
                labelWrapper="col-form-label col-form-label-sm col-12 text-muted"
                fieldWrapper="col-12"
                bWrapper="row mb-2"
                tooltip={props.tooltip}
                {...props}
            />
        );
    };

    renderFlags = (props) => {
        return (
            <Flags
                value={this.state.data[props.inputProps.name]}
                onChange={this.setValue}
                labelWrapper="col-form-label col-form-label-sm col-12 text-muted"
                fieldWrapper="col-12"
                bWrapper="row mb-2"
                {...props}
            />
        );
    };

    renderSelect = (props) => {
        return (
            <Select
                key={props.key || props.label}
                wrapper="panel__row"
                onChange={this.setValue}
                value={this.state.data[props.inputProps.name]}
                labelWrapper="col-form-label col-form-label-sm col-12 text-muted"
                fieldWrapper="col-12"
                bWrapper="row mb-2"
                {...props}
            />
        );
    };

    renderCheckbox = (props) => {
        return (
            <Checkbox
                key={props.key || props.label}
                onChange={this.setValue}
                value={this.state.data[props.inputProps.name]}
                fieldBeforeLabel
                labelWrapper="col-auto col-form-label col-form-label-sm pl-0"
                fieldWrapper="col-auto"
                bWrapper="row flex-nowrap w-100 align-items-center"
                tooltip={props.tooltip}
                {...props}
            />
        );
    };

    renderBody = () => {
        return null;
    };

    renderButton = () => {
        const cname = cn("btn btn-brand btn-sm", { disabled: !this.state.shouldUpdate });
        return (
            this.props.editable && (
                <div className="panel__row panel__row--button">
                    <div className={cname} onClick={this.update}>
                        Обновить
                    </div>
                </div>
            )
        );
    };

    render() {
        const cname = cn("card card-body mb-3", { "border-danger": !this.state.isValid });
        return (
            <div className={cname}>
                {this.renderBody()}
                {this.renderButton()}
            </div>
        );
    }
}
